const PREFIX = "webmhis:";

export function startClientSession(token, user, username, role = "cliente") {
  sessionStorage.setItem(`${PREFIX}jwt`, token);
  sessionStorage.setItem(`${PREFIX}logged`, "ok");
  sessionStorage.setItem(`${PREFIX}role`, role);
  const fields = {
    S: "Sicurezza",
    F: "Formazione",
    M: "Medicina",
    Cliente: "Cliente",
    Notarizzazione: "Notarizzazione",
    Email: "Email",
    Dettaglio: "Dettaglio",
    Medico: "ID",
  };
  Object.entries(fields).forEach(([key, field]) => {
    sessionStorage.setItem(`${PREFIX}${key}`, user[field] ?? "");
  });
  sessionStorage.setItem(`${PREFIX}User`, username);
}

export function endClientSession() {
  [sessionStorage, localStorage].forEach((storage) => {
    Object.keys(storage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => storage.removeItem(key));
  });
}
